import request from '../../utils/request';

export function filesUpload(params) {
  return request({
    url: '/files/upload',
    method: 'post',
    data: params,
  });
}

export function avatarUpload(params) {
  return request({
    url: '/files/upload/avatar',
    method: 'post',
    data: params,
  });
}

export const syncDID = () => {
  return request.post('/user-center/sync-did')
}